import { render } from "./MessageText.vue?vue&type=template&id=33dcdc58&scoped=true"
import script from "./MessageText.vue?vue&type=script&lang=js"
export * from "./MessageText.vue?vue&type=script&lang=js"

import "./MessageText.vue?vue&type=style&index=0&id=33dcdc58&scoped=true&lang=css"
import "./MessageText.vue?vue&type=style&index=1&id=33dcdc58&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33dcdc58"],['__file',"src/components/MessageText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33dcdc58"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33dcdc58', __exports__)) {
    api.reload('33dcdc58', __exports__)
  }
  
  module.hot.accept("./MessageText.vue?vue&type=template&id=33dcdc58&scoped=true", () => {
    api.rerender('33dcdc58', render)
  })

}


export default __exports__